// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-admin-cache',
    data: () => ({
        cache: [],
        isLoading: false
    }),
    created() {
        this.loadCache();
    },
    beforeMount() {
        this.$host.eventBus.on('refresh', this.loadCache);
    },
    beforeUnmount() {
        this.$host.eventBus.off('refresh', this.loadCache);
    },
    methods: {
        loadCache() {
            //set
            this.isLoading = true;
            host.api.get(`admin/cache`).then((e) => {
                //Product
                this.cache = e.data;
                //Loading
                this.isLoading = false;
            }).catch(e => {
                this.isLoading = false;
                host.notification.showToast(utils.getAxiosErrorMessage(e), "error");
            });
        },
        deleteCache(event, item) {
            //Item
            event.preventDefault();
            //Run
            host.api.delete(`admin/cache/clear/${encodeURIComponent(item.name)}`).then((e) => {
                this.cache.splice(this.cache.indexOf(item), 1);
            }).catch(e => {
                host.notification.showToast(utils.getAxiosErrorMessage(e), "error");
            });
        },
    }
});
// #endregion
